import React from 'react';

const SmallWorld = ({ height = 16, width = 16, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <title>small world</title>
    <g fill={color}>
      <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-1.5,0-2.8-0.5-3.9-1.4 c0.6-0.8,0.7-1.8,0.1-2.6C3.7,9.3,2.9,8.6,2.9,8c0-0.8,1.9-1.1,2.5-1.9C6.1,5.3,5.4,3.8,4.7,3c0.8-0.5,1.7-0.9,2.8-1 c0.2,0.5,0.9,1.1,1.2,1.5c0.5,0.8,0.6,1.3,1.3,1.3c0.2,0,2,0,3-0.3C13.6,5.5,14,6.7,14,8C14,11.3,11.3,14,8,14z" fill={color}/>
      <path d="M10.2,6.7C9,6.7,7.9,7.5,8,8.6c0.3,2.5-0.5,3.4,0.6,3.9c1.3,0.5,3.9-1.9,3.8-3.9 C12.4,7.5,11.5,6.7,10.2,6.7z"/>
    </g>
  </svg>
);

export default SmallWorld;
